export default "/assets/images/mila-feed-06-thumbnail.jpg?2550439da8adf6ce3ebaea148cd4c3dd";